import { makeStyles } from '@material-ui/core/styles';

/**
 * Typography system for RevenueCommandCenter component
 * Based on Google Font "Onest" with Display and Text size scales
 * Each size has 4 weight variants: Regular (400), Medium (500), Semibold (600), Bold (700)
 */

// Helper function to convert px to rem
const pxToRem = (px) => `${px / 16}rem`;

export const useRccTypography = makeStyles(() => ({
  fontFamily: {
    fontFamily: '"Onest", sans-serif',
  },

  // Display Large (48px / 3rem)
  displayLargeRegular: {
    fontFamily: '"Onest", sans-serif',
    fontSize: pxToRem(48),
    lineHeight: pxToRem(60),
    letterSpacing: '-0.02em',
    fontWeight: 400,
  },
  displayLargeMedium: {
    fontFamily: '"Onest", sans-serif',
    fontSize: pxToRem(48),
    lineHeight: pxToRem(60),
    letterSpacing: '-0.02em',
    fontWeight: 500,
  },
  displayLargeSemibold: {
    fontFamily: '"Onest", sans-serif',
    fontSize: pxToRem(48),
    lineHeight: pxToRem(60),
    letterSpacing: '-0.02em',
    fontWeight: 600,
  },
  displayLargeBold: {
    fontFamily: '"Onest", sans-serif',
    fontSize: pxToRem(48),
    lineHeight: pxToRem(60),
    letterSpacing: '-0.02em',
    fontWeight: 700,
  },

  // Display Medium (36px / 2.25rem)
  displayMediumRegular: {
    fontFamily: '"Onest", sans-serif',
    fontSize: pxToRem(36),
    lineHeight: pxToRem(44),
    letterSpacing: '-0.02em',
    fontWeight: 400,
  },
  displayMediumMedium: {
    fontFamily: '"Onest", sans-serif',
    fontSize: pxToRem(36),
    lineHeight: pxToRem(44),
    letterSpacing: '-0.02em',
    fontWeight: 500,
  },
  displayMediumSemibold: {
    fontFamily: '"Onest", sans-serif',
    fontSize: pxToRem(36),
    lineHeight: pxToRem(44),
    letterSpacing: '-0.02em',
    fontWeight: 600,
  },
  displayMediumBold: {
    fontFamily: '"Onest", sans-serif',
    fontSize: pxToRem(36),
    lineHeight: pxToRem(44),
    letterSpacing: '-0.02em',
    fontWeight: 700,
  },

  // Display Small (30px / 1.875rem)
  displaySmallRegular: {
    fontFamily: '"Onest", sans-serif',
    fontSize: pxToRem(30),
    lineHeight: pxToRem(38),
    fontWeight: 400,
  },
  displaySmallMedium: {
    fontFamily: '"Onest", sans-serif',
    fontSize: pxToRem(30),
    lineHeight: pxToRem(38),
    fontWeight: 500,
  },
  displaySmallSemibold: {
    fontFamily: '"Onest", sans-serif',
    fontSize: pxToRem(30),
    lineHeight: pxToRem(38),
    fontWeight: 600,
  },
  displaySmallBold: {
    fontFamily: '"Onest", sans-serif',
    fontSize: pxToRem(30),
    lineHeight: pxToRem(38),
    fontWeight: 700,
  },

  // Display Extra Small (24px / 1.5rem)
  displayExtraSmallRegular: {
    fontFamily: '"Onest", sans-serif',
    fontSize: pxToRem(24),
    lineHeight: pxToRem(32),
    fontWeight: 400,
  },
  displayExtraSmallMedium: {
    fontFamily: '"Onest", sans-serif',
    fontSize: pxToRem(24),
    lineHeight: pxToRem(32),
    fontWeight: 500,
  },
  displayExtraSmallSemibold: {
    fontFamily: '"Onest", sans-serif',
    fontSize: pxToRem(24),
    lineHeight: pxToRem(32),
    fontWeight: 600,
  },
  displayExtraSmallBold: {
    fontFamily: '"Onest", sans-serif',
    fontSize: pxToRem(24),
    lineHeight: pxToRem(32),
    fontWeight: 700,
  },

  // Text Extra Large (20px / 1.25rem)
  textExtraLargeRegular: {
    fontFamily: '"Onest", sans-serif',
    fontSize: pxToRem(20),
    lineHeight: pxToRem(30),
    fontWeight: 400,
  },
  textExtraLargeMedium: {
    fontFamily: '"Onest", sans-serif',
    fontSize: pxToRem(20),
    lineHeight: pxToRem(30),
    fontWeight: 500,
  },
  textExtraLargeSemibold: {
    fontFamily: '"Onest", sans-serif',
    fontSize: pxToRem(20),
    lineHeight: pxToRem(30),
    fontWeight: 600,
  },
  textExtraLargeBold: {
    fontFamily: '"Onest", sans-serif',
    fontSize: pxToRem(20),
    lineHeight: pxToRem(30),
    fontWeight: 700,
  },

  // Text Large (18px / 1.125rem)
  textLargeRegular: {
    fontFamily: '"Onest", sans-serif',
    fontSize: pxToRem(18),
    lineHeight: pxToRem(28),
    fontWeight: 400,
  },
  textLargeMedium: {
    fontFamily: '"Onest", sans-serif',
    fontSize: pxToRem(18),
    lineHeight: pxToRem(28),
    fontWeight: 500,
  },
  textLargeSemibold: {
    fontFamily: '"Onest", sans-serif',
    fontSize: pxToRem(18),
    lineHeight: pxToRem(28),
    fontWeight: 600,
  },
  textLargeBold: {
    fontFamily: '"Onest", sans-serif',
    fontSize: pxToRem(18),
    lineHeight: pxToRem(28),
    fontWeight: 700,
  },

  // Text Medium (16px / 1rem)
  textMediumRegular: {
    fontFamily: '"Onest", sans-serif',
    fontSize: pxToRem(16),
    lineHeight: pxToRem(24),
    fontWeight: 400,
  },
  textMediumMedium: {
    fontFamily: '"Onest", sans-serif',
    fontSize: pxToRem(16),
    lineHeight: pxToRem(24),
    fontWeight: 500,
  },
  textMediumSemibold: {
    fontFamily: '"Onest", sans-serif',
    fontSize: pxToRem(16),
    lineHeight: pxToRem(24),
    fontWeight: 600,
  },
  textMediumBold: {
    fontFamily: '"Onest", sans-serif',
    fontSize: pxToRem(16),
    lineHeight: pxToRem(24),
    fontWeight: 700,
  },

  // Text Small (14px / 0.875rem)
  textSmallRegular: {
    fontFamily: '"Onest", sans-serif',
    fontSize: pxToRem(14),
    lineHeight: pxToRem(20),
    fontWeight: 400,
  },
  textSmallMedium: {
    fontFamily: '"Onest", sans-serif',
    fontSize: pxToRem(14),
    lineHeight: pxToRem(20),
    fontWeight: 500,
  },
  textSmallSemibold: {
    fontFamily: '"Onest", sans-serif',
    fontSize: pxToRem(14),
    lineHeight: pxToRem(20),
    fontWeight: 600,
  },
  textSmallBold: {
    fontFamily: '"Onest", sans-serif',
    fontSize: pxToRem(14),
    lineHeight: pxToRem(20),
    fontWeight: 700,
  },

  // Text Extra Small (12px / 0.75rem)
  textExtraSmallRegular: {
    fontFamily: '"Onest", sans-serif',
    fontSize: pxToRem(12),
    lineHeight: pxToRem(18),
    fontWeight: 400,
  },
  textExtraSmallMedium: {
    fontFamily: '"Onest", sans-serif',
    fontSize: pxToRem(12),
    lineHeight: pxToRem(18),
    fontWeight: 500,
  },
  textExtraSmallSemibold: {
    fontFamily: '"Onest", sans-serif',
    fontSize: pxToRem(12),
    lineHeight: pxToRem(18),
    fontWeight: 600,
  },
  textExtraSmallBold: {
    fontFamily: '"Onest", sans-serif',
    fontSize: pxToRem(12),
    lineHeight: pxToRem(18),
    fontWeight: 700,
  },

  // Text Label (10px / 0.5rem)
  textLabelRegular: {
    fontFamily: '"Onest", sans-serif',
    fontSize: pxToRem(10),
    lineHeight: pxToRem(14),
    fontWeight: 400,
  },
  textLabelMedium: {
    fontFamily: '"Onest", sans-serif',
    fontSize: pxToRem(10),
    lineHeight: pxToRem(14),
    fontWeight: 500,
  },
  textLabelSemibold: {
    fontFamily: '"Onest", sans-serif',
    fontSize: pxToRem(10),
    lineHeight: pxToRem(14),
    fontWeight: 600,
  },
  textLabelBold: {
    fontFamily: '"Onest", sans-serif',
    fontSize: pxToRem(10),
    lineHeight: pxToRem(14),
    fontWeight: 700,
  },
}));

